import React, { useContext } from 'react';
import FlexColumn from '../components/shared/FlexColumn';
import CategoryEvents from '../components/edit/CategoryEvents';
import FlexRow from '../components/shared/FlexRow';
import UserContext from '../context/UserContext';
import { API } from '../utils/API';
import { apiConfig } from '../utils/apiConfig';

export default function Edit({ token }) {
  const { role } = useContext(UserContext);
  const [events, setEvents] = React.useState([]);
  const [newEvent0, setNewEvent0] = React.useState('');
  const [newEvent1, setNewEvent1] = React.useState('');
  const [newEvent2, setNewEvent2] = React.useState('');
  const [newEvent3, setNewEvent3] = React.useState('');

  const downloadEvents = async () => {
    const target = apiConfig.event.eventsFromConfig;
    const req = await fetch(target);
    const response = await req.json();
    console.log(response);

    let events = [];
    if (response.status) {
      for (const row of response.rows) {
        events.push(row.events);
      }
    }
    setEvents(events);
  };

  const removeEvent = async (rowNumber, url) => {
    try {
      if (!url) throw 'Please fill valid URL';
      let newEventsUrls = events[rowNumber].filter((event) => event.Url !== url).map((event) => event.Url);
      const body = {
        events: [...newEventsUrls],
        document_type: `event_row_${rowNumber}`,
      };
      const res = await API(apiConfig.forumSettings.updateEvents, 'POST', body);
      if (res.status) {
        alert('CHANGES SUCCESS');
        downloadEvents();
      }
    } catch (error) {
      alert(error);
    }
  };

  React.useEffect(() => {
    downloadEvents();
  }, []);

  const handleAddEvent = async (rowNumber, url) => {
    try {
      if (!url) throw 'Please fill valid URL';
      let newEventsUrls = events[rowNumber].map((event) => event.Url);
      const body = {
        events: [...newEventsUrls, url],
        document_type: `event_row_${rowNumber}`,
      };
      const res = await API(apiConfig.forumSettings.updateEvents, 'POST', body);
      if (res.status) {
        alert('CHANGES SUCCESS');
        downloadEvents();
      }
    } catch (error) {
      alert(error);
    }
  };

  return (
    <FlexColumn expand={styles.container}>
      <h2>עמוד הבית</h2>
      <h3>כרטיסים</h3>
      {role === 'admin' && (
        <FlexRow>
          <input
            value={newEvent0}
            style={styles.input}
            placeholder="Url example:(1702241337157)"
            onChange={(e) => setNewEvent0(e.target.value)}
          />
          <button style={styles.saveButton} onClick={() => handleAddEvent(0, newEvent0)}>
            הוספת אירוע חדש
          </button>
        </FlexRow>
      )}
      <CategoryEvents events={events[0]} removeEvent={removeEvent} rowNumber={0} />
      <h3>כרטיסים והסעות</h3>
      {role === 'admin' && (
        <FlexRow>
          <input
            value={newEvent1}
            style={styles.input}
            placeholder="Url example:(1702241337157)"
            onChange={(e) => setNewEvent1(e.target.value)}
          />
          <button style={styles.saveButton} onClick={() => handleAddEvent(1, newEvent1)}>
            הוספת אירוע חדש
          </button>
        </FlexRow>
      )}
      <CategoryEvents events={events[1]} removeEvent={removeEvent} rowNumber={1} />
      <h3>שולחנות</h3>
      {role === 'admin' && (
        <FlexRow>
          <input
            value={newEvent1}
            style={styles.input}
            placeholder="Url example:(1702241337157)"
            onChange={(e) => setNewEvent1(e.target.value)}
          />
          <button style={styles.saveButton} onClick={() => handleAddEvent(2, newEvent2)}>
            הוספת אירוע חדש
          </button>
        </FlexRow>
      )}
      <CategoryEvents events={events[2]} removeEvent={removeEvent} rowNumber={2} />
      <h3>מלון</h3>
      {role === 'admin' && (
        <FlexRow>
          <input
            value={newEvent3}
            style={styles.input}
            placeholder="Url example:(1702241337157)"
            onChange={(e) => setNewEvent3(e.target.value)}
          />
          <button style={styles.saveButton} onClick={() => handleAddEvent(3, newEvent3)}>
            הוספת אירוע חדש
          </button>
        </FlexRow>
      )}
      <CategoryEvents events={events[3]} removeEvent={removeEvent} rowNumber={3} />
    </FlexColumn>
  );
}

const styles = {
  container: {
    paddingBottom: 150,
  },
  input: {
    width: 300,
    padding: 8,
    borderRadius: 6,
    border: '1px solid #ccc',
    fontSize: 14,
    marginLeft: 10,
  },
  saveButton: {
    backgroundColor: '#8f3cc0',
    color: '#fff',
    padding: '10px 24px',
    border: 'none',
    borderRadius: 24,
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 16,
  },
};
